module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-right-item social"
  }, [_c('p', {
    staticClass: "title-info"
  }, [_vm._v("\n        至少有一种通讯类型成功通过验证，否则帐号可能会在不限定期内被回收。\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "validate-list"
  }, [_c('li', {
    staticClass: "list-item clearfix"
  }, [_c('div', {
    staticClass: "col-left",
    class: {
      'validate-ok': _vm.statusList[0].status
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope pre-icon"
  }), _vm._v("邮箱验证\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-right clearfix"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.statusList[0].status) ? _c('span', [_vm._v("\n          您验证的邮箱："), _c('span', {
    staticClass: "strong"
  }, [_vm._v(_vm._s(_vm.statusList[0].value))])]) : _c('span', [_vm._v(" 未验证邮箱 ")])]), _vm._v(" "), _c('div', {
    staticClass: "operation"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "data-operation": _vm.statusList[0].status ? 'modify' : 'validate'
    },
    on: {
      "click": function($event) {
        return _vm.operation($event, 'email')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.statusList[0].status ? "修改" : "开始验证")), _c('i', {
    staticClass: "bk-icon icon-play"
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-item clearfix"
  }, [_c('div', {
    staticClass: "col-left",
    class: {
      'validate-ok': _vm.statusList[1].status
    }
  }, [_c('i', {
    staticClass: "fa fa-phone pre-icon"
  }), _vm._v("手机验证\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-right clearfix"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.statusList[1].status) ? _c('span', [_vm._v("\n          您验证的手机："), _c('span', {
    staticClass: "strong"
  }, [_vm._v(_vm._s(_vm.statusList[1].value))])]) : _c('span', [_vm._v(" 未验证手机号 ")])]), _vm._v(" "), _c('div', {
    staticClass: "operation"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;",
      "data-operation": _vm.statusList[1].status ? 'modify' : 'validate'
    },
    on: {
      "click": function($event) {
        return _vm.operation($event, 'phone')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.statusList[1].status ? "修改" : "开始验证")), _c('i', {
    staticClass: "bk-icon icon-play"
  })])])])]), _vm._v(" "), _c('li', {
    staticClass: "list-item clearfix"
  }, [_c('div', {
    staticClass: "col-left",
    class: {
      'validate-ok': _vm.statusList[2].status
    }
  }, [_c('i', {
    staticClass: "fa fa-wechat pre-icon"
  }), _vm._v("订阅微信通知\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-right clearfix"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.isSubscritionPublic && _vm.isSubscritionWxchat) ? _c('span', [_vm._v("\n          已订阅\n        ")]) : _c('span', [_vm._v("未订阅")])]), _vm._v(" "), _c('div', {
    staticClass: "operation"
  }, [(_vm.isSubscritionPublic && _vm.isSubscritionWxchat) ? _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.unSubscription
    }
  }, [_vm._v("取消订阅"), _c('i', {
    staticClass: "bk-icon icon-play"
  })]) : _c('a', {
    attrs: {
      "href": "javascript:;",
      "data-operation": 'validate'
    },
    on: {
      "click": _vm.subscription
    }
  }, [_vm._v("\n                        订阅\n                        "), _c('i', {
    staticClass: "bk-icon icon-play"
  })])])])])]), _vm._v(" "), _c('popup', {
    attrs: {
      "title": _vm.popup.title,
      "show": _vm.popup.isShow
    },
    on: {
      "close": _vm.closePopup
    }
  }, [_c(_vm.currentView, {
    tag: "div",
    attrs: {
      "slot": "popup-body",
      "current-view": _vm.currentView,
      "modify_view": _vm.modify_view,
      "v_type": _vm.vTypeForOtherValidate,
      "info": _vm.statusList,
      "finish_title": _vm.finish_title
    },
    on: {
      "bind_email_success": _vm.bind_email_success,
      "next": _vm.nextStep,
      "finish": _vm.validateFinish,
      "getStatus": _vm.getStatus,
      "errorResult": _vm.errorResult
    },
    slot: "popup-body"
  })], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-e4262c6c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/profile/social.vue
// module id = hREM
// module chunks = 15